export default {
    mapper: {
        relations: {
            belongsTo: {
                trackingNumber: {
                    foreignKey: 'tracking_number_id',
                    localField: 'trackingNumber',
                },
            },
        },
    },
};
